export const defaultTitle = 'FUPP: Hottest TikTok Porn and TikTok Nudes HD Sex Videos';
export const defaultDescription = 'FUPP is the Free Porn site to watch TikTok Porn Videos. We optimize NSFW and XXX Porn Videos for viewing on your mobile.'
